import React, { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import mergePersons from '../../../Services/Mutations/MergePersonsUpdate'

function MergePersons() {
  const [duplicatePersonId, setDuplicatePersonId] = useState()
  const [originalPersonId, setOriginalPersonId] = useState()
  const [noDuplicateDataBtnDisable, setNoDuplicateDataBtnDisable] = useState(true)
  const [noOriginalDataBtnDisable, setNoOriginalDataBtnDisable] = useState(true)
  // const [sameIdsShowValidation, setSameIdsShowValidation] = useState(false)
  const handleDuplicatePersonId = event => {
    setNoDuplicateDataBtnDisable(event.target.value.length <= 0)
    setDuplicatePersonId(event.target.value)
  }

  const handleOriginalPersonId = event => {
    setNoOriginalDataBtnDisable(event.target.value.length <= 0)

    setOriginalPersonId(event.target.value)
  }

  const mergeData = async () => {
    const input = {
      person1: originalPersonId,
      person2: duplicatePersonId,
    }

    try {
      const response = await mergePersons(input)

      if (response.data === 'persons merged Successfully') {
        toast.success('Merged persons Successfully')
      } else {
        toast.error('Merged persons failed')
      }
    } catch (error) {
      console.error('Error while merging persons:', error)
      toast.error('Error while merging persons')
    }
  }

  const isMergeDisabled = () =>
  noDuplicateDataBtnDisable ||
  noOriginalDataBtnDisable ||
    duplicatePersonId === originalPersonId

  return (
    <div>
      <label className='mb-5'>Merge Persons</label>
      <div className='d-flex gap-4'>
        <div className='d-flex'>
          <label className='m-2'>Move</label>
          <input
            onChange={handleDuplicatePersonId}
            value={duplicatePersonId}
            placeholder='Duplicate Person ID'
            type='text'
            className='form-control'
            id='duplicatePersonId'
          />
        </div>
        <div className='d-flex flex-column gap-3 align-items-end'>
          <div className='d-flex'>
            <label className='m-2'>to</label>
            <input
              onChange={handleOriginalPersonId}
              value={originalPersonId}
              placeholder='Original Person ID'
              type='text'
              className='form-control'
              id='originalPersonId'
            />
          </div>
          {duplicatePersonId === originalPersonId ? (
            <p className='fs-6 text-danger'>Original and Duplicate IDs should not be same</p>
          ) : (
            ''
          )}
        </div>
        <div>
          <button
            disabled={isMergeDisabled()}
            onClick={mergeData}
            className='btn btn-primary'
          >
            Merge
          </button>
        </div>
      </div>
      <ToastContainer
        position='top-right'
      />
    </div>
  )
}

export default MergePersons
